@if (admin(); as adminData) {
  <div class="admin-profile-container">

    <!-- Header Card -->
    <div class="profile-header">
      <div class="header-content">

        @if (profilePhotoUrl) {
          <img
            [src]="profilePhotoUrl"
            alt="Profile Photo"
            class="avatar profile-avatar" />
        } @else {
          <p-avatar
            [label]="getInitials()"
            size="xlarge"
            class="avatar"
            [style]="{
              'background-color': '#F908B7',
              'color': '#ffffff',
              'font-size': '2rem',
              'width': '100px',
              'height': '100px'
            }">
          </p-avatar>
        }

        <div class="header-info">
          <div class="flex align-items-center gap-2 mb-2">
            <h2 class="user-name">{{ adminData.user.firstName }}</h2>
            <p-tag
              [value]="getRoleDisplay(adminData.user.role)"
              [styleClass]="getRoleSeverity(adminData.user.role)"
              [icon]="getRoleIcon(adminData.user.role)"
              styleClass="role-badge"/>
          </div>
          <div class="user-email">
            <i class="pi pi-envelope mr-2"></i>
            {{ adminData.user.email }}
          </div>
        </div>

      </div>
    </div>

    <!-- Account Settings -->
<app-account-setting [email]="email"></app-account-setting>

  </div>
}